import React, { useContext } from 'react';
import { Checkbox } from 'anf-core-react';
import { Controller, useFormContext } from 'react-hook-form';
import useSwitchesFromContext from '../../../hooks/useSwitchesFromContext';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import { MARKETING_CODE_FOR_NFL_PRODUCTS } from '../../../tools/constants';

export default function NFLDataSharingConsent() {
  const { getSwitchValue } = useSwitchesFromContext();
  const { control } = useFormContext();
  const { checkoutPageState } = useContext(CheckoutPageContext);
  const { textFor, bagItems } = checkoutPageState || {};
  const hasNFLItemInBag = bagItems?.items.some((
    bagItem,
  ) => bagItem?.item?.productContent?.marketingCode === MARKETING_CODE_FOR_NFL_PRODUCTS);
  const enableNflDataSharingConsent = getSwitchValue('enableNflDataSharingConsent');
  if (!enableNflDataSharingConsent || !hasNFLItemInBag) {
    return null;
  }

  return (
    <div className="nfl-consent">
      <h3>
        {textFor?.nflDataSharingConsentHeading?.value}
      </h3>
      <Controller
        name="nflDataSharingOptedIn"
        control={control}
        render={({ field }) => (
          <Checkbox
            description={textFor?.nflDataSharingConsent?.value}
            id="nflDataSharingOptedIn-id"
            isChecked={field.value}
            {...field}
          />
        )}
      />
    </div>
  );
}
